export default __webpack_public_path__ + "static/media/5-suporte.8b84268b.svg";